(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = document.querySelectorAll('[data-reveal]');
  reveal.forEach(el => el.classList.add('ks-reveal'));
  if (!reduced && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    }), { threshold: .12 });
    reveal.forEach(el => io.observe(el));
  } else reveal.forEach(el => el.classList.add('is-visible'));

  const toggle = document.querySelector('.ks-menu-toggle');
  const nav = document.querySelector('.ks-nav');
  if (toggle && nav) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open);
  });

  document.querySelectorAll('[data-product]').forEach(root => {
    const data = root.querySelector('[data-variants]');
    if (!data) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    const optionGroups = [...root.querySelectorAll('[data-option-index]')];
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const availability = root.querySelector('[data-availability]');
    const gallery = root.querySelector('.ks-gallery');
    const mainProductImage = gallery?.querySelector('[data-ks-main-image]');
    const setGalleryImage = (url) => {
      if (!url || !mainProductImage) return;
      mainProductImage.src = url;
      mainProductImage.removeAttribute('srcset');
      mainProductImage.removeAttribute('sizes');
      const urlPath = new URL(url, window.location.origin).pathname;
      gallery.querySelectorAll('[data-gallery-image]').forEach(button => {
        const active = new URL(button.dataset.galleryImage, window.location.origin).pathname === urlPath;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    if (gallery) {
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-gallery-image]');
        if (!button || !gallery.contains(button)) return;
        setGalleryImage(button.dataset.galleryImage);
        if (mainProductImage && button.dataset.galleryAlt) mainProductImage.alt = button.dataset.galleryAlt;
        mainProductImage?.animate([{opacity:.45,transform:'scale(.98)'},{opacity:1,transform:'scale(1)'}], {duration:260,easing:'ease-out'});
      });
      const zoom = gallery.querySelector('.ks-gallery-zoom');
      if (zoom && mainProductImage) zoom.addEventListener('click', () => {
        if (mainProductImage.requestFullscreen) mainProductImage.requestFullscreen();
      });
    }
    const currency = '{{ cart.currency.iso_code }}' || 'EUR';
    const money = amount => {
      const n = Number(amount) || 0;
      const value = n > 9999 ? n / 100 : n;
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style:'currency', currency }).format(value);
    };
    const update = () => {
      const values = optionGroups.map(group => group.querySelector('input:checked')?.value || '');
      optionGroups.forEach(group => {
        const current = group.querySelector('.ks-option-current');
        if (current) current.textContent = values[Number(group.dataset.optionIndex)] || '';
      });
      const finishGroup = optionGroups.find(group => group.dataset.optionName === 'Finition');
      const selectedChip = finishGroup?.querySelector('input:checked')?.closest('.ks-option-chip');
      const imageUrl = selectedChip?.dataset.image;
      if (imageUrl && mainProductImage) {
        setGalleryImage(imageUrl);
        mainProductImage.animate([{opacity:.45,transform:'scale(.985)'},{opacity:1,transform:'scale(1)'}], {duration:260,easing:'ease-out'});
      }
      const variant = variants.find(v => v.options.every((value, i) => value === values[i]));
      if (!variant) { if (addButton) addButton.disabled = true; return; }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'AJOUTER AU PANIER' : 'INDISPONIBLE';
      if (availability) availability.textContent = variant.available ? 'Disponible' : 'Indisponible pour le moment';
    };
    optionGroups.forEach(group => group.addEventListener('change', update));
    update();
  });


})();